export default __webpack_public_path__ + "static/media/21_Epi_GG-Quiz-Art_baking_tin_VOG.fa1a2cd2.png";